import React from "react";
import "./Experienced.css";
import DetailsImage from "../../../../assets/images/experienced-section.png";
import DetailsDots from "../../../../assets/images/aboutus-dots.png";
const Experienced = () => {
  return (
    <div className="experienced_section">
      <img src={DetailsDots} alt="" className="experienced__section_dots" />
      <div className="experienced__section_left">
        <img src={DetailsImage} alt="" className="experienced__section_img" />
      </div>
      <div className="experienced__section_right">
        <div className="experienced__secleft_heading">Experienced</div>
        <div className="experienced__secleft_description">
          <p>
            We are a team of experienced professionals who serve the U.S
            community by helping with U.S tax laws. Our team has been built for
            the process through experienced knowledge and the caliber of hard
            work. Our firm’s reputation reflects in our high standards,
            services, and specialized staff make sure that every client is
            served by the expertise of our whole firm and each individuals’
            strengths.
          </p>
          <p>
            As a dynamic CPA firm, we strive to adapt to our client’s
            situations, while we help develop the right plan for the success of
            each client’s needs. We welcome you to contact us anytime.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Experienced;
